import { WelcomeBackground } from '../welcome-background';
import { getIamLoginUrl, shouldUseIamFlowForCurrentHost } from '../../utils/iam-login-url';
import './styles.less';
const {
  Link
} = ReactRouterDOM;
const {
  Card,
  CardBody,
  CardHeader
} = svs.ui.ReactCard;
const {
  ReactIcon: Icon,
  ReactBank: BankId
} = svs.ui;
const {
  Grid,
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  SiteHeaderBrand
} = svs.retailUi;
const LoginCardLink = ({
  isExternal,
  href,
  to,
  children
}) => {
  if (isExternal) {
    return <a href={href}>
        {children}
      </a>;
  }
  return <Link to={to}>
      {children}
    </Link>;
};
const Welcome = () => {
  const isIamLoginEnabled = shouldUseIamFlowForCurrentHost(svs.core.detect.feature('ft-iam-login'));
  const bankIdLink = isIamLoginEnabled ? getIamLoginUrl('/logga-in/dev-login') : '/logga-in/bank-id';
  const usernameLink = isIamLoginEnabled ? getIamLoginUrl('/logga-in/dev-user-login') : '/logga-in/anvandarnamn';
  return <WelcomeBackground className="component-welcome f-content">
      <div className="welcome-inner padding-bottom-3 margin-bottom-4">
        <div>
          <SiteHeaderBrand isDarkText size="large" />
        </div>
        <div className="f-center margin-bottom-4">
          <p>Det här är din Ombudsportal.  Här hittar du allt som kan hjälpa dig i din vardag. Logga in och ta del av allt.</p>
        </div>

        <Grid>
          <GridRow>
            <GridCol>
              <LoginCardLink href={bankIdLink} isExternal={isIamLoginEnabled} to={bankIdLink}>
                <Card className="login-link">
                  <CardHeader className="bg-red">
                    <div className="icon-circle">
                      <BankId name="bankid" size="30" />
                    </div>
                  </CardHeader>
                  <CardBody className="u-flex u-flex-justify-content-between">
                    Bank-id

                    <Icon icon="arrow-right" />
                  </CardBody>
                </Card>
              </LoginCardLink>
            </GridCol>

            <GridCol>
              <LoginCardLink href={usernameLink} isExternal={isIamLoginEnabled} to={usernameLink}>
                <Card className="login-link login-username">
                  <CardHeader>
                    <div className="icon-circle">
                      <Icon icon="user" size="500" />
                    </div>
                  </CardHeader>
                  <CardBody className="u-flex u-flex-justify-content-between">
                    Användarnamn

                    <Icon icon="arrow-right" />
                  </CardBody>
                </Card>
              </LoginCardLink>
            </GridCol>
          </GridRow>
        </Grid>
      </div>
    </WelcomeBackground>;
};
export default Welcome;